import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    margin: '12px 0'
  },
  header: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  subTitle: {
    color: theme.palette.grey[600],
    fontSize: 13,
    marginBottom: theme.spacing(2)
  },
  listContainer: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: 6,
    padding: theme.spacing(2)
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),

    '&:last-child': {
      marginBottom: 0
    }
  },
  icon: {
    fontSize: 18,
    color: theme.palette.secondary.main,
    marginRight: theme.spacing(1)
  },
  text: {
    fontSize: 14
  }
}))
export default useStyles
